import { render, staticRenderFns } from "./bookForm.vue?vue&type=template&id=048bbffd&"
import script from "./bookForm.vue?vue&type=script&lang=js&"
export * from "./bookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports